module.exports = __webpack_public_path__ + "img/pop-healed.58e58806.svg";